export const isValidImage = (url: string): boolean => {
  return /\.(png|jpg|jpeg|gif)$/i.test(url);
};

export const isValidId = (id: string | number): boolean => {
  return /^[a-zA-Z0-9_-]{3,}$/.test(String(id)); // Convert id to string before testing
};